import React, {useContext} from 'react';
import {Badge, Typography} from "@material-ui/core";
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";
import {useDrop} from "react-dnd";
import {AcceptTypes} from "../../ToolBar/ToolBarUtils/ItemTypes";
import RenderComponents from "./RenderByType/RenderComponents";


const BadgeComponent = ({component, path, index: parentIndex}) => {
    const {onDropComponent, onDropMultipleComponents, onMoveComponent} = useContext(ScreenDesignerContextNew);
    const {styles: sourceStyles, children = []} = component;
    const styles = sourceStyles && sourceStyles.length ? sourceStyles[0] : {};
    const hasChildren = children && children.length;

    const [{isOverCurrent}, drop] = useDrop({
        accept: AcceptTypes.badge,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
        }),
        drop: (item, monitor) => {
            const didDrop = monitor.didDrop();
            if (didDrop) {
                return;
            }

            if (item.dragType === 'multiple') {
                onDropMultipleComponents(item.component, 0, `${path}.children`);
                return
            }
            if (item.dragType === 'move') {
                onMoveComponent(item.component, item.from, `${path}.children`, children.length, item.index, parentIndex);
                return
            }

            onDropComponent(item, children.length, `${path}.children`)
        }
    });
    return (
        <div ref={drop} style={{width: '100%', height: '100%'}}>
            <Badge badgeContent={1} color={styles.color || "secondary"} variant={styles.variant || "dot"} style={{minHeight: 15, minWidth: 35}}>
                {hasChildren ? (
                    children.map((item, index) => {
                        return (
                            <RenderComponents
                                key={index}
                                type={item.type}
                                item={item}
                                index={index}
                                path={`${path}.children.${index}`}
                                parentPath={path}
                            />
                        )
                    })
                ) : <Typography color={"textSecondary"}>Badge</Typography>}
            </Badge>
        </div>
    )
}

export default BadgeComponent;